import { FC } from "react";

import { FieldSeparator } from "@fronterahealth/frontera-ui-components/ui/field";

import { useCreateReportSectionsMutation } from "@api/graphql/types-and-hooks";
import { notifyError } from "@components/notifications/notifications";
import { useReport } from "@providers/ReportProvider";

export const ReportSectionAddContent: FC<{
  pageLocation: string;
  newRankOrder: number;
}> = ({ pageLocation, newRankOrder }) => {
  const { report, reportQuery } = useReport();
  const { mutate: mutateCreateSection, isPending } = useCreateReportSectionsMutation({
    onSuccess: async (data) => {
      if (data.createReportSections?.status) {
        await reportQuery.refetch();
      } else if (data.createReportSections?.status === false) {
        notifyError(data.createReportSections?.message ?? "Error adding section");
      }
    },
    onError: (error) => {
      console.error("Error while adding section:", error);
      notifyError("Error Adding Section");
    },
  });

  return (
    <FieldSeparator
      onClick={() => {
        mutateCreateSection({
          reportId: report.id,
          runWorkflow: false,
          sections: [{ title: "Enter Section Title", pageLocation, rankOrder: newRankOrder }],
        });
      }}
      className="cursor-pointer opacity-0 hover:opacity-100 transition-opacity"
    >
      {isPending ? "Creating..." : "Add Section"}
    </FieldSeparator>
  );
};
